import * as React from "react";
function SvgTrash(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M19.5625 5.125H16.6328L15.3047 2.9375C14.9531 2.35156 14.3672 2 13.7031 2H9.75781C9.09375 2 8.50781 2.35156 8.15625 2.9375L6.82812 5.125H3.89844C3.39062 5.125 3 5.55469 3 6.0625C3 6.53125 3.39062 7 3.89844 7H4.25L5.07031 20.2422C5.10938 21.2578 5.92969 22 6.94531 22H16.5156C17.5312 22 18.3516 21.2578 18.3906 20.2422L19.25 7H19.5625C20.0703 7 20.5 6.60938 20.5 6.0625C20.5 5.55469 20.0703 5.125 19.5625 5.125ZM9.75781 3.875H13.7031L14.4453 5.125H9.01562L9.75781 3.875ZM16.5156 20.125H6.94531L6.125 7H17.3359L16.5156 20.125Z" style={{
      fill: "var(--svg-color, var(--default-svg-color, #000))"
    }} /></svg>;
}
const ForwardRef = React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "src/assets/icons/trash.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/trash_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/trash_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/trash_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/trash_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/trash_4x.svg"
};
export { ForwardRef as ReactComponent };